import { FlagWrapper } from './LangButton.styles';
import { UsFlag, BrFlag, EsFlag, MxFlag, CoFlag, GlobalFlag } from './flags';

const FLAGS = {
  EN: UsFlag,
  PT: BrFlag,
  ES: EsFlag,
  MX: MxFlag,
  CO: CoFlag,
  GLOBAL: GlobalFlag,
};

export default function LangButton({ label = 'EN', width = 24, height = 18 }) {
  const Flag = FLAGS[label] || UsFlag;

  return (
    <FlagWrapper width={width} height={height}>
      <Flag />
    </FlagWrapper>
  );
}

export { LangButton };
